import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance"

export const deleteSavedMerchant = (merchantId: string) => {
    return axiosPrivate.delete(`/bills/api/v1/distributor/beneficiaries/${merchantId}/`)
}